import React from 'react';
import { NavLink } from 'react-router-dom';

const tabs = [
  { to: '/backoffice/clientes', label: 'Clientes' },
  { to: '/backoffice/fichas', label: 'Fichas de Reserva' },
  { to: '/backoffice/servicios', label: 'Servicios' },
  { to: '/backoffice/operadores', label: 'Operadores' },
  { to: '/backoffice/gastos', label: 'Gastos' },
  { to: '/backoffice/rentabilidad', label: 'Rentabilidad' },
];

const NavTabs = () => (
  <div className="nav-tabs">
    {tabs.map((tab) => (
      <NavLink
        key={tab.to}
        to={tab.to}
        className={({ isActive }) => `nav-tab ${isActive ? 'active' : ''}`}
      >
        {tab.label}
      </NavLink>
    ))}
  </div>
);

export default NavTabs;
